import img from './img';
import audio from './audio';
import dataConfig from './gameData.config.js';

var config = {
  author: 'MZ',
  engine: 'LookPointAndListen',
  icon: 'Dusty', // ['Dusty', 'Tom', 'Lisa'],
  title: [
    {
      text: 'Look and choose.',
      cssStyle: { height: '9%', 'font-family': 'Linotype' },
    },
  ],
  gameConfig: dataConfig,
  checkGameSound: {
    positive: [
      'games/page005_game1/audio/M_Brilliant.mp3',
      'games/page005_game1/audio/M_Excellent.mp3',
      'games/page005_game1/audio/M_Fantastic.mp3',
      'games/page005_game1/audio/M_Great.mp3',
      'games/page005_game1/audio/M_Perfect.mp3',
      'games/page005_game1/audio/M_Very good.mp3',
      'games/page005_game1/audio/M_Well done.mp3',
    ],
    negative: [
      'games/page005_game1/audio/M_Think again.mp3',
      'games/page005_game1/audio/M_Try again.mp3',
      'games/page005_game1/audio/M_Work harder.mp3',
    ],
  },
  assets: {
    img: img || [],
    audio: audio || [],
    extendetJS: [],
    extendetStyle: [],
  },
};

export default config;
